import { Product, SimproApi, SimproJob, SimproJobDetails, SimproJobDetailsInData } from '@/api';
import { AxiosError, AxiosResponse, AxiosStatic } from 'axios';
import { ApiUtils } from '@/common/ApiUtils';
import Toast from '@/components/display/toast.vue';

export class SimproService {
	private simproApi: SimproApi;

	constructor(simproApi: SimproApi = new SimproApi()) {
		this.simproApi = simproApi;
	}

	private delay(ms: number): Promise<void> {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	public async getSimproJobDetails(
		simprojobs: SimproJobDetails[],
		axios: AxiosStatic,
		product?: Product,
	): Promise<SimproJobDetails[]> {
		const jobs: SimproJobDetails[] = [];
		const filteredJobs = simprojobs?.filter(
			(job: any) => !product?.id || job.productId === product?.id,
		);

		for (const simproJob of filteredJobs) {
			if (simproJob.id != null) {
				try {
					// Add a 250ms delay between requests
					// to try and avoid simPRO API rate limiting
					await this.delay(250);

					const res = await this.simproApi.getSimproJobDetails(simproJob.id);
					if (res.data.data !== undefined) {
						// @ts-ignore
						if (res.data.data.original && res.data.data.original.errors) {
							// @ts-ignore
							throw { response: { data: { errors: res.data.data.original.errors } } };
						} else {
							if (!Array.isArray(res.data.data)) {
								// @ts-ignore
								if (!res.data.data.installer)
									// @ts-ignore
									res.data.data.installer = res.data.data.technician;
								jobs.push(res.data.data);
							}
						}
					}
				} catch (err) {
					console.error('simPRO Get Job Details Error:', err);
					const { errorMessage } = ApiUtils.handleApiError(
						err,
						`Error getting simPRO job with ID '${simproJob.id}'`,
						`getting simPRO job with ID '${simproJob.id}'`,
					);
					new Toast().makeToast(errorMessage, 'Error Getting simPRO Job', 'danger', true);
				}
			}
		}
		return jobs;
	}
}
